
import { ref, Ref } from "vue";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import program_routes from "@/api/routes/programs";

import StructureFactory from "@/models/structure/factory";
import { Debounce } from "@/helpers";
import CStructure, { IStructureProp } from "@/components/Structure.vue";
import CPaginatedSelect from "@/components/PaginatedSelect.vue";

import { IProgramAssignmentAvailableProgram } from "./Edit.vue";

@Component({
  name: "CProgramAssignmentsEditPositions",
  components: {
    CPaginatedSelect,
    CStructure
  }
})
export default class CProgramAssignmentsEditProgram extends Vue {
  @Prop({ required: true })
  public program!: IProgramAssignmentAvailableProgram | null;

  @Prop({ required: true }) public factories!: StructureFactory[];

  public programs_search: string = "";

  public show_filter: boolean = false;
  public filters_count: number = 0;
  public filters: Map<string, boolean> = new Map();

  public factory_id: string | null = null;
  public structure: IStructureProp = {};

  public selected_program = this.program;
  private reload_programs_fn: Function | null = null;

  public setReloadPrograms(reload_fn: Function) {
    this.reload_programs_fn = reload_fn;
  }

  public async clearFilters() {
    this.filters.clear();

    this.factory_id = null;
    this.structure = {};

    this.filters_count = this.filters.size;

    if (this.reload_programs_fn) {
      this.reload_programs_fn.call(null);
    }
  }

  @Watch("programs_search")
  @Debounce(500)
  protected async searchPrograms() {
    if (this.reload_programs_fn) {
      this.reload_programs_fn.call(null);
    }
  }

  public allowWrite() {
    return this.$api.allowWrite();
  }

  public changeSelectedProgram(
    program: IProgramAssignmentAvailableProgram | null
  ) {
    this.selected_program = program;

    this.$emit("change", this.selected_program);
  }

  public async changeFactoryFilter() {
    if (this.factory_id) {
      this.filters.set("factory", true);
    } else {
      this.filters.delete("factory");
    }

    this.structure = {};

    this.filters_count = this.filters.size;

    if (this.reload_programs_fn) {
      this.reload_programs_fn.call(null);
    }
  }

  public async changeStructureFilter(structure: IStructureProp) {
    this.structure = structure;

    if (this.reload_programs_fn) {
      this.reload_programs_fn.call(null);
    }
  }

  public async loadProgramsFn(page: number = 0) {
    return this.$api
      .get(program_routes.assignment_available_programs, {
        params: {
          page,
          per_page: 50,
          search: this.programs_search,
          factory_id: this.factory_id,
          infinity_id: this.structure.infinity_id ?? null,
          section_id: (this.$router.currentRoute.meta! as IRouteMeta)
            .permissions?.[0]
        }
      })
      .then(
        ({
          data: res
        }: {
          data: { programs: IProgramAssignmentAvailableProgram[] };
        }) => {
          if (res.programs.length) {
            return res.programs;
          }

          return [];
        }
      );
  }
}
